
// import Router from 'vue-router'

import Vue from 'vue'

import CommonRouter from './common.router.js'
import LoginRouter from '../pages/login/routers/login.router.js'
import FrameRouter from './pages.router.js'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

let routerArray = []

routerArray = routerArray.concat(CommonRouter.routers)
routerArray = routerArray.concat(LoginRouter.routers)
routerArray = routerArray.concat(FrameRouter.routers)

const appRouter = new VueRouter({
  mode: 'history',
  routes: routerArray,
  savaScrollPosition: true
})

appRouter.beforeEach((to, from, next) => {
  let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
  if (to.meta.auth) {
    if (userInfo && userInfo.token) {
      next()
    } else {
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
    }
  } else {
    next()
  }
  document.title = to.meta.title
})

export default appRouter



// WEBPACK FOOTER //
// ./src/router/router.js